import {React,useEffect,useState } from 'react';
import { NavLink,useNavigate } from 'react-router-dom';
import {
  UserCircle,
  Briefcase,
  Calendar,
  Zap,
  Bell,
  Settings,
  LogOut,Star,User,CreditCard,Users,Video,UserCheck
} from 'lucide-react';
import { Nav, Container } from 'react-bootstrap';



import  fetchUserJogetProfileApi  from '../../../services/api';
import  {useAuth}  from '../../../context/AuthContext';
import ChangePasswordPage from '../../dashboard/ChangePasswordPage';
import DirectorProfilePage from './DirectorProfilePage';

import './DirectorSidebar.css'

const DirectorSidebar = () => {

  
  
    const [applications, setApplications] = useState([]);
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [showDrawer, setShowDrawer] = useState(false);
    const handleClose = () => setShowDrawer(false);
      const [profile, setProfile] = useState({
        c_yourName: '',
        role: '',
        isVerified: false,
        photoURL: ''
      });
    
    const handleLogout = () => {
      logout();
      handleClose();
      navigate('/login');
    };  

    
    const hasPermission = (moduleKey, action = 'View') => {
    // CD (400) Bypass
    if (String(user?.roleCode || user?.role_code) === '200') {
      return true;
    }
    const perms = user?.permissions || [];
    return perms.includes(`${moduleKey}:${action}`);
  };

  // USER DATA (Copied logic from TalentSidebar)
  const displayName = user?.full_name || 'Director';
  const displayRole = user?.role || 'Director';
  const profileImageUrl = user?.profile_image_url || '';

  // FALLBACK AVATAR
  const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=d90429&color=fff&size=150`;

  const imageSource = profileImageUrl ? profileImageUrl : defaultAvatar;

  return (
    <div className="dir-sidebar py-4">

      {/* 🔥 CARD 1 (PROFILE + MENU + LOGOUT) */}
      <div className="dir-main-card mt-5">

        {/* PROFILE */}
       
       <div className="sidebar-profile text-center mb-4">

          <img
            src={imageSource}
            alt="Casting Director"
            className="td-profile-img"
            onError={(e) => {
              e.target.src = defaultAvatar;
            }}
          />

          <h4>{displayName}</h4>

          <p>{displayRole}</p>

        </div>

        {/* MENU */}
         <div className="dir-sidebar-nav">
        
                  {hasPermission('Dashboard', 'View') && (
                  <NavLink
                    to="/dashboard/overview"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <User size={18} /> Dashboard
                  </NavLink>
                  )}
                  {hasPermission('Dashboard', 'View') && (
                  <NavLink
                    to="/dashboard/profile"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <UserCircle size={16} /> Profile
                  </NavLink>
                  )}
        
                  {hasPermission('Dashboard', 'View') && (
                  <NavLink
                    to="/dashboard/projects"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <Briefcase size={18} /> Projects
                  </NavLink>
                  )}
        
                  {hasPermission('Dashboard', 'View') && (
                  <NavLink
                    to="/dashboard/roles"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <Users size={18} /> Manage Roles
                  </NavLink>
                  )}

                  {hasPermission('Dashboard', 'View') && (
                  <NavLink
                    to="/dashboard/manage-applications"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <Users size={16} /> Audition
                  </NavLink>
                  )}

                {hasPermission('Meetings', 'View') && ( // ✅ Changed key to 'Meetings'
                <NavLink
                  to="/dashboard/meetings"
                  className={({ isActive }) =>
                    isActive ? "cd-menu-item active" : "cd-menu-item"
                  }
                >
                  <Video size={16} /> Meetings
                </NavLink>
                )}
              
              {/* 8. Team Members Link */}
                {hasPermission('Team', 'View') && (
                  <NavLink 
                    to="/dashboard/team-members" 
                    className={({ isActive }) => 
                      isActive ? "cd-menu-item active" : "cd-menu-item"
                    }
                  >
                    <UserCheck size={16} /> Team Members
                  </NavLink>
                )}

                  {hasPermission('Dashboard', 'View') && (
                  <NavLink
                    to="/dashboard/director-testimonials"
                    className={({ isActive }) =>
                      isActive
                        ? "cd-menu-item active"
                        : "cd-menu-item"
                    }
                  >
                    <Star size={18} />
                     Reviews
                  </NavLink>
                  )}

                  {hasPermission('Dashboard', 'View') && (
                  <NavLink
                    to="/dashboard/transaction-history"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <CreditCard size={16} /> Billing
                  </NavLink>
                  )}
        
                </div>
        

        {/* LOGOUT */}
        <div className="logout" onClick={handleLogout}>
          <LogOut size={16} /> Sign Out
        </div>


      </div>

    
      
      {/* <div className="dir-pro-card">
  
  <div className="pro-title ">
    <Star size={16} />
    <span>Pro Features</span>
  </div>

  <p className="pro-text">
    Unlock AI self-tape scoring and priority role matching.
  </p>

  <button className="pro-btn">
    Upgrade Now
  </button>

</div> */}

    </div>
  );
};

export default DirectorSidebar;